
const navigation = () => {
    return [
      // {
      //   sectionTitle: 'Divider'
      // },
      {
        title: 'Dashboard',
        value: 'Dashboard',
        icon: 'tabler:category',
        path: '/dashboard'
      },
      {
        title: 'Customers',
        value: 'Customer',
        icon: 'tabler:user-square',
        path: '/customers'
      },
      {
        title: 'Employees',
        value: 'Employee',
        icon: 'tabler:user-check',
        path: '/employees'
      },
      {
        sectionTitle: 'FirstDivider'
      },
      {
        title: 'Requests',
        value: 'ServiceRequest',
        icon: 'tabler:square-arrow-down',
        path: '/requests'
      },
      {
        title: 'Assessments',
        value: 'ServiceRequest',
        icon: 'tabler:map-pin',
        path: '/assessments'
      },
      {
        title: 'Estimates',
        value: 'ServiceRequest',
        icon: 'tabler:calculator',
        path: '/estimates'
      },
      {
        title: 'Work Orders',
        value: 'ServiceRequest',
        icon: 'tabler:list-check',
        path: '/work-orders'
      },
      {
        title: 'Dispatch Board',
        value: 'DispatchBoard',
        icon: 'tabler:truck-delivery',
        path: '/dispatch-board'
      },
      {
        title: 'Invoices',
        value: 'Invoice',
        icon: 'tabler:invoice',
        path: '/invoices'
      },
      {
        title: 'Payments',
        value: 'Payment',
        icon: 'tabler:credit-card',
        path: '/payments'
      },
      {
        sectionTitle: 'SecondDivider'
      },
       {
        title:'Reports',
        value: 'Reports',
        icon: 'lsicon:report-outline',
        path: '/reports'
      },
      {
        title: 'Services',
        value: 'Services',
        icon: 'tabler:tool',
        path: '/services'
      },
      {
        title: 'Inventory',
        value: 'Inventory',
        icon: 'tabler:notebook',
        path: '/inventory'
      },
      {
        title: 'QuickBooks',
        value: 'Quickbooks',
        icon: 'simple-icons:qbittorrent',
        path: '/quickbooks'
      },
      // {
      //   title: 'Settings',
      //   value: 'Settings',
      //   icon: 'tabler:settings',
      //   path: '/settings'
      // },
      // {
      //   title: 'User',
      //   icon: 'tabler:user',
      //   children: [
      //     {
      //       title: 'List',
      //       path: '/apps/user/list'
      //     },
      //     {
      //       title: 'View',
      //       children: [
      //         {
      //           title: 'Account',
      //           path: '/apps/user/view/account'
      //         },
      //         {
      //           title: 'Security',
      //           path: '/apps/user/view/security'
      //         },
      //         {
      //           title: 'Billing & Plans',
      //           path: '/apps/user/view/billing-plan'
      //         },
      //         {
      //           title: 'Notifications',
      //           path: '/apps/user/view/notification'
      //         },
      //         {
      //           title: 'Connection',
      //           path: '/apps/user/view/connection'
      //         }
      //       ]
      //     }
      //   ]
      // },
    ]
  }
  
  export default navigation
  